import { Select, SelectProps } from '@chakra-ui/react';
import { useError, useSuccess } from '@pelicargo/ui';
import { FPAllowedShipmentStatuses, shipmentStatusOptions } from '@pelicargo/utils';
import { ShipmentStatus } from '@prisma/client';
import { useCallback } from 'react';

import { trpc } from '../config/trpc';

type Props = SelectProps & {
  requestId: number;
  callback: () => any;
  isLoading?: boolean;
  currentStatus: ShipmentStatus;
};

const alertOn = [
  ShipmentStatus.PICKUP_COMPLETE,
  ShipmentStatus.AT_WAREHOUSE,
  ShipmentStatus.OUT_FOR_DELIVERY,
  ShipmentStatus.AIRLINE_ACCEPTED,
];

export const FPShipmentStatus = ({ requestId, callback, isLoading, currentStatus, ...rest }: Props) => {
  const { mutateAsync: updateRequest, isLoading: isUpdatingRequest } = trpc.updateRequest.useMutation();
  const { handleError } = useError();
  const { handleSuccess } = useSuccess();
  const { mutateAsync: sendEmailAsync, isLoading: isSending } = trpc.sendFFShipmentStatusEmail.useMutation();

  const sendEmail = useCallback(async () => {
    try {
      await sendEmailAsync({
        requestId,
      });
      handleSuccess('An email has been sent to the customer to inform them');
    } catch (e) {
      handleError(e);
    }
  }, [handleError, handleSuccess, requestId, sendEmailAsync]);

  const onSelect = useCallback(
    async (e) => {
      await updateRequest({
        id: requestId,
        shipment_status: e.target.value as any,
      });
      if (alertOn.includes(e.target.value)) {
        sendEmail();
      }
      callback();
    },
    [callback, requestId, sendEmail, updateRequest],
  );

  return (
    <>
      <Select
        defaultValue={currentStatus}
        size="sm"
        w="40"
        onChange={onSelect}
        fontWeight="medium"
        {...rest}
        disabled={isUpdatingRequest || isLoading || isSending}
      >
        <option value={''}>-</option>
        {shipmentStatusOptions.map((opt) => (
          <option value={opt.value} disabled={!FPAllowedShipmentStatuses.includes(opt.value as any)} key={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </>
  );
};
